import deCHMessages from 'src/i18n/de_ch.json5';
// import deDEMessages from 'src/i18n/de_de.json5';
// export const deDE = deDEMessages
export const deCH = deCHMessages